import React from "react";
import { Link } from "gatsby";
import { MdMoreHoriz } from "react-icons/md";
import { css } from "@emotion/react";

const ReadMoreWhite = ({ ...props }) => (
  <Link
    to={props.link}
    css={css`
      display: block;
      text-align: right;
      margin-right: 2em;
    `}
    title={props.title}
  >
    <span
      css={css`
        background-color: white;
        padding: 0.3em 0.1em 0em;
        transition: all 0.15s ease;
        border-radius: 3px;
        &:hover {
          background-color: #1c1f1b;
          transition: all 0.15s ease;
        }
      `}
    >
      <MdMoreHoriz
        css={css`
          font-size: 20px;
          color: black;
          transform: translateY(2px);
          &:hover {
            color: white;
            transition: all 0.15s ease;
          }
        `}
      />
    </span>
  </Link>
);

export default ReadMoreWhite;
